const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20avatar%20illustration%20of%20a%20young%20woman%20with%20warm%20smile%2C%20clean%20minimal%20style%2C%20coral%20warm%20tones%2C%20profile%20picture%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '小糖豆',
    time: '2小时前',
    comic: '《霸总的契约恋人》',
    content: '天哪这部漫画真的太甜了！下拉式阅读模式看恋爱漫画简直不要太爽，一口气追了50话停不下来。男主又帅又宠，女主也不是傻白甜，剧情节奏把控得特别好。',
    likes: 328,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20illustration%20of%20a%20young%20man%20with%20confident%20expression%2C%20clean%20minimal%20style%2C%20amber%20warm%20tones%2C%20profile%20picture%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '追漫少年',
    time: '5小时前',
    comic: '《重生之都市修仙》',
    content: '布丁漫画的下拉式阅读真的太适合看修仙漫画了！打斗场面的连贯性完美呈现，不像翻页那样会被打断。这部漫画的剧情也越来越精彩了，期待主角突破元婴期后的新篇章。',
    likes: 256,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20avatar%20illustration%20of%20a%20girl%20with%20glasses%20and%20gentle%20smile%2C%20clean%20minimal%20style%2C%20warm%20coral%20tones%2C%20profile%20picture%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '漫画控小葵',
    time: '8小时前',
    comic: '《绝世剑神》',
    content: '从第一话追到现在，真的是一部值得反复看的好漫画。布丁漫画的画质也很清晰，下拉式模式让剑法招式的呈现特别带感。听说马上要大结局了，又期待又不舍得！',
    likes: 412,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20avatar%20illustration%20of%20a%20young%20person%20with%20friendly%20expression%2C%20clean%20minimal%20style%2C%20warm%20amber%20tones%2C%20profile%20picture%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '暗夜读书人',
    time: '1天前',
    comic: '《暗夜追踪者》',
    content: '刚入坑布丁漫画，被朋友安利了这部悬疑漫画。下拉式阅读体验确实比其他平台好太多了，完全不卡顿。剧情烧脑又刺激，每一话结尾都留悬念，根本停不下来！',
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              读者点评
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              布丁漫画读者们的真实阅读感受和漫画推荐
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {comments.map((item, i) => (
              <div
                key={i}
                className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.time} · {item.comic}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.content}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-heart-line"></i> {item.likes}
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-chat-1-line"></i> 回复
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-share-forward-line"></i> 分享
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}